// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__222Pw","rootSuccess":"CompleteLink_rootSuccess__3eDmL","rootFailure":"CompleteLink_rootFailure__31867","isDisabled":"CompleteLink_isDisabled__3_eoF"};